module.exports = __webpack_public_path__ + "img/wethrivehub-icon.1c478210.png";